export const MAX_FILE_SIZE = 50 * 1024 * 1024;
export const MAX_AUDIO_SIZE = 100 * 1024 * 1024;

export const MAX_FILE_SIZES: Record<string, number> = {
  // PDF
  "pdf": MAX_FILE_SIZE,

  // Excel
  "xls":
    MAX_FILE_SIZE,
  "xlsx": MAX_FILE_SIZE,

  // Doc
  "doc": MAX_FILE_SIZE,
  "docx":
    MAX_FILE_SIZE,

  // HEIC image
  "heic": MAX_FILE_SIZE,

  // Video
  "mp4": MAX_AUDIO_SIZE,

  // Audio
  "mp3": MAX_AUDIO_SIZE,

  // Images
  "png": MAX_FILE_SIZE,
  "jpeg": MAX_FILE_SIZE,
  "jpg": MAX_FILE_SIZE,
  "webp": MAX_FILE_SIZE,
};

export const SUPPORTED_FILE_EXTS = [
  "application/pdf",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/vnd.ms-excel",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "audio/mpeg",
  "audio/mp3",
  "video/mp4",
  "image/png",
  "image/jpeg",
  "image/jpg",
  "image/webp",
  "image/heif",
  "image/heic",
];
